export type FontWeight = 'normal' | 'semibold' | 'bold' | 'heading';

export const fontWeights: Record<FontWeight, number> = {
	normal: 400,
	semibold: 600,
	bold: 700,
	heading: 700,
};
